import {CrossDomainDecorator} from './cross-domain';
import {subscribeToNavigation} from './navigation';
import {isBrowser} from './utils';

export class BrowserLifecycle {
  private running = false;
  private flushTimer: number | null = null;
  private unsubscribeNavigation: (() => void) | null = null;

  constructor(
    private readonly crossDomain: CrossDomainDecorator,
    private readonly flushIntervalMs: number,
    private readonly onNavigation: () => void,
    private readonly onFlush: () => void,
  ) {
  }

  isRunning(): boolean {
    return this.running;
  }

  start(): void {
    if (!isBrowser() || this.running) return;
    this.running = true;
    this.unsubscribeNavigation = subscribeToNavigation(this.onNavigation);
    this.crossDomain.start();
    window.addEventListener('online', this.handleOnline);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    this.flushTimer = window.setInterval(this.onFlush, this.flushIntervalMs);
  }

  stop(): void {
    if (!isBrowser() || !this.running) return;
    this.running = false;
    this.unsubscribeNavigation?.();
    this.unsubscribeNavigation = null;
    this.crossDomain.stop();
    window.removeEventListener('online', this.handleOnline);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    if (this.flushTimer !== null) window.clearInterval(this.flushTimer);
    this.flushTimer = null;
  }

  private readonly handleOnline = (): void => {
    this.onFlush();
  };

  private readonly handleVisibilityChange = (): void => {
    if (document.visibilityState === 'visible') this.onFlush();
  };
}
